export default __webpack_public_path__ + "static/media/avatar-Six.09d71ccf.svg";